import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Divider from '@material-ui/core/Divider';

const RequestDetailsSkeleton = () => {

    return (
        <>
            <Skeleton height={40} width="15%" />
            <Skeleton height={35} width="25%" />
            <Skeleton height={90} />
            <Skeleton height={90} />
            <Divider />
            <Skeleton height={30} width="15%" />
            <Skeleton height={20} />
        </>
    );
}

export default RequestDetailsSkeleton;